import React, { useState, useContext } from "react";
import { Col, Row, Card, Form, Button } from "react-bootstrap";
import { CSSTransition } from "react-transition-group";
import { Link } from "react-scroll";
import UseRegularBanner from "./RegularBanner";
import { isMobile } from "react-device-detect";
import { Link as RouterLink } from "react-router-dom";

import AdThumbnail from "components/AdThumbnail";

import HandDown from "./Svg/HandDown";
import HandRight from "./Svg/HandRight";

import { useSqliteAdCache } from "hooks/query";
import { useSection } from "hooks/section";
import { useMetadata } from "hooks/query";

import "./SearchAside.css";
import { useEffect } from "react";
import FilterRow from "./FilterRow";
import { SearchContext, isBoosted } from "./AdSearchManager/SearchContext";
import { isDefaultSearch } from "./AdSearchManager/IsDefaultSearch";

import { useSearchParams, useLocation, matchRoutes, useNavigate, useParams } from "react-router-dom";
import queryString from "query-string";
import CenterSpinner from "./CenterSpinner";

const routes = [
    { path: "/:section/utbildning/:slug" },
    { path: "/:section" },
    { path: "/" },
    { path: "/:section/:slug" },
    { path: "*" },
];

const useCurrentPath = () => {
    const location = useLocation();
    const [{ route }] = matchRoutes(routes, location);
    return route.path;
};

function ScrollToTop() {
    useEffect(() => {
        if (!isMobile) {
            window.scrollTo({
                top: 0,
                left: 0,
                behavior: "instant",
            });
        }
    }, [location.search]);

    return null;
}
export default function SearchAside({ showResults, adCache = true, children }) {
    const { results, searchState } = useContext(SearchContext);
    const [isVisible, setIsVisible] = useState(false);
    const location = useLocation();
    let db = null;
    if(adCache) {
        db = useSqliteAdCache();
    }        
    useEffect(() => {
        window.addEventListener("scroll", listenToScroll);
        return () => window.removeEventListener("scroll", listenToScroll);
    }, []);

    if (adCache && db.data) {
        let result = db.data.exec("SELECT COUNT(*) FROM ad");
        console.log({ result });
    }

    const listenToScroll = () => {
        let heightToShowFrom = 1000;
        const winScroll = document.body.scrollTop || document.documentElement.scrollTop;

        if (winScroll > heightToShowFrom) {
            setIsVisible(true);
        } else {
            setIsVisible(false);
        }
    };

    const [showImageMap, setShowImageMap] = useState(false);
    const [showSearch, setShowSearch] = useState(false);
    const [showButton, setShowButton] = useState(true);
    const { sectionUrl, sectionEnum } = useSection();

    const metadataQuery = useMetadata();
    const [lookupResults, setLookupResults] = useState();
    const banners = UseRegularBanner();

    const ToggleClass = () => {
        setShowSearch(!showSearch);
    };

    return (
        <div className="SearchAside mt-5">
            { !metadataQuery.isSuccess ?
            <CenterSpinner /> :
            <>
            <ScrollToTop />
            <Row>
                { searchState &&
                    searchState.filters &&
                    <Col id="SearchBox" xl={2} md={12}>
                        <SearchBox
                            adCache={adCache}
                            setShowImageMap={setShowImageMap}
                            showSearch={showSearch}
                            setShowSearch={setShowSearch}
                            ToggleClass={ToggleClass}
                            showButton={showButton}
                            setShowButton={setShowButton}
                            banners={banners}
                            sectionUrl={sectionUrl}
                            results={results}
                            filters={searchState.filters}
                            freetext={searchState.freetext}
                            setFreetext={searchState.setFreetext}
                            relations={searchState.relations}
                            lookupResults={lookupResults}
                            setLookupResults={setLookupResults}
                        />
                    </Col>
                }
                <Col xl={10} md={12} id="result">
                    {location.search && showResults ? 
                        <>                        
                            { searchState && 
                                searchState.filters && searchState.filters.find(f => f.header === "SEKTION").data[0] == 2 &&
                                searchState.filters && searchState.filters.find(f => f.header === "UNDERKATEGORIER").data.length > 0 &&
                                <>
                                    <p>Läs mer om: &nbsp;
                                        { searchState.filters.find(f => f.header === "UNDERKATEGORIER").data.map((fk, index) => {
                                            let foundTag = metadataQuery.data.tags.$values.find(v => v.value == fk);
                                            return (
                                                <RouterLink to={`/eftergymnasial-utbildning/yrkesroll/${foundTag.key}`}>
                                                    &nbsp;{foundTag.value}
                                                    { index !== searchState.filters &&
                                                        (searchState.filters.find(f => f.header === "UNDERKATEGORIER")
                                                            .data.length - 1) ? <> |</> : <></> }
                                                </RouterLink>
                                            )
                                            }
                                        )}
                                    </p>
                                </>
                            }
                            <Results results={results} banners={banners} /> 
                        </>
                        : <>{children}</>}

                    {isVisible && (
                        <div id="hide" className="no-desktop">
                            <Link to="root" spy={true} smooth={true}>
                                <img
                                    className="pil"
                                    src="https://res.cloudinary.com/hm7cvv3hp/image/upload/v1648716483/us/nedladdning.png"
                                />{" "}
                                UPP
                            </Link>
                        </div>
                    )}
                </Col>
            </Row>
            </> }
        </div>
    );
}

function SearchBox({
    adCache,
    filters,
    showSearch,
    showButton,
    ToggleClass,
    sectionUrl,
    relations,
    freetext,
    setFreetext,
    lookupResults,
    setLookupResults,
}) {
    const { results, searchState } = useContext(SearchContext);
    const BtnText = showSearch ? "Stäng filter" : "Visar filter & Sök";
    const top = window.location.pathname == "/studentjobb" ? 500 : "unset";

    let ResultText = "Ingen träff";
    console.log("ISDEFAULTSEARCH", isDefaultSearch(searchState), searchState);
    if (isDefaultSearch(searchState)) {
        ResultText = "";
    } else if (results.length === 1) {
        ResultText = "1 träff";
    } else {
        ResultText = results.length + " träffar";
    }

    return (
        <>
            <div className="no-desktop SearchBox">
                {showButton && (
                    <button
                        className="btn btnBorder btnWidth"
                        id="sowFilterBtn"
                        onClick={() => {
                            ToggleClass();
                            window.scrollTo({ top: top, left: 0, behavior: "smooth" });
                        }}
                    >
                        {BtnText}
                    </button>
                )}
                <CSSTransition
                    in={showSearch}
                    timeout={400}
                    classNames="no-desktop list-transition"
                    unmountOnExit
                    appear
                >
                    <SearchBoxElement
                        adCache={adCache}
                        filters={filters}
                        relations={relations}
                        results={results}
                        freetext={freetext}
                        setFreetext={setFreetext}
                        sectionUrl={sectionUrl}
                        lookupResults={lookupResults}
                        setLookupResults={setLookupResults}
                        ResultText={ResultText}
                    />
                </CSSTransition>
            </div>
            <div className="no-mobile SearchBox">
                <SearchBoxElement
                    adCache={adCache}
                    filters={filters}
                    relations={relations}
                    results={results}
                    freetext={freetext}
                    setFreetext={setFreetext}
                    sectionUrl={sectionUrl}
                    lookupResults={lookupResults}
                    setLookupResults={setLookupResults}
                    ResultText={ResultText}
                ></SearchBoxElement>
            </div>
        </>
    );
}

function Results({ banners }) {
    const { searchState, results } = useContext(SearchContext);

    if (results.length === 0 && !isDefaultSearch(searchState)) {
        return (
            <>
                <p className="p-5" style={{ textAlign: "center" }}>
                    Inga träffar{" "}
                </p>
                <div className="grid m-5">
                    {banners &&
                        banners.map((regBanner) => {
                            return (
                                <div>
                                    <a href={regBanner?.homePage} className="stortavlaa">
                                        <img
                                            className="img-fluid"
                                            src={regBanner.largeUrl}
                                            loading="lazy"
                                            alt="regular-banner"
                                        ></img>
                                    </a>
                                </div>
                            );
                        })}
                </div>
            </>
        );
    }

    if (isDefaultSearch(searchState)) {
        return <div></div>;
    }
    let resultCopy = [];
    [...results]
        .filter((r) => r.boost)
        .forEach((r) => {
            resultCopy.push(r);
        });
    [...results]
        .filter((r) => !r.boost)
        .forEach((r) => {
            resultCopy.push(r);
        });

    return (
        <>
            <div className="grid mb-5">
                {resultCopy.splice(0, 100).map((ad, index) => {
                    let shortdescription = ad.shortdescription ? ad.shortdescription.substring(0, 150) + "..." : "";                   
                    let discount = Math.floor((ad.dealamount > 0) ? ad.dealamount : (ad.dealpercentage > 0) ? ad.price * ad.dealpercentage / 100: 0).toString();
                    return (
                        <>
                            <AdThumbnail
                                key={ad.$id}
                                slug={ad.urlbase}
                                title={ad.name}
                                logoUrl={ad.img}
                                description={shortdescription}
                                boost={isBoosted(searchState, ad.boosted_subjects)}
                                dealDiscount={discount}
                            />
                            {index == 1 && banners && results.length >= 3 && (
                                <div>
                                    <a href={banners[0]?.homePage} className="stortavlaa">                                                                             
                                        <img
                                            className="img-fluid stortavla"
                                            src={banners[0]?.largeUrl}
                                            loading="lazy"
                                            alt="regular-banner"
                                        ></img>
                                    </a>
                                </div>
                            )}
                            {index == 2 && banners && (
                                <div>
                                    <a href={banners[1]?.homePage} className="stortavlaa">                                                                    
                                        <img
                                            className="img-fluid stortavla"
                                            src={banners[1]?.largeUrl}
                                            loading="lazy"
                                            alt="regular-banner"
                                        ></img>
                                    </a>
                                </div>
                            )}
                            {((index == 3 && banners) || (banners && results.length == 3 && index == 2)) && (
                                <div>
                                    <a href={banners[2]?.homePage} className="stortavlaa">                                                                  
                                        <img
                                            className="img-fluid stortavla"
                                            src={banners[2]?.largeUrl}
                                            loading="lazy"
                                            alt="regular-banner"
                                        ></img>
                                    </a>
                                </div>
                            )}
                        </>
                    );
                })}
                {results.length < 3 && (
                    <>
                        {banners.map((regBanner) => {
                            return (
                                <div>
                                    <a href={regBanner?.homePage} className="stortavlaa">
                                        <img
                                            className="img-fluid stortavla"
                                            src={regBanner?.largeUrl}
                                            loading="lazy"
                                            alt="regular-banner"
                                        ></img>
                                    </a>
                                </div>
                            );
                        })}
                    </>
                )}
            </div>
        </>
    );
}

function SearchBoxElement({ sectionUrl, ResultText, lookupResults, setLookupResults, adCache = true }) {
    const { results, searchState } = useContext(SearchContext);
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const { section, slug } = useParams();

    let sqliteAdCache = null;
    if(adCache) {
        sqliteAdCache = useSqliteAdCache();
    }
    
    const HitIndicator = ({ results }) => {
        const path = useCurrentPath();
        return (
            <Row>
                <span style={{ height: "24px" }}>
                    {path !== "/:section/utbildning/:slug" && results.length === 0 && !isDefaultSearch(searchState) && <span>Inga träffar</span>}
                    {isDefaultSearch(searchState) && <span></span>}
                    {results.length != 0 && !isDefaultSearch(searchState) && (
                        <span>
                            <Link to="result" spy={true} smooth={true} href="#result">
                                {ResultText}
                            </Link>
                            <Link className="no-desktop" to="result" spy={true} smooth={true} href="#result">
                                <HandDown />
                            </Link>
                            <Link className="no-mobile" to="result" spy={true} smooth={true} href="#result">
                                <HandRight />
                            </Link>
                        </span>
                    )}
                </span>
            </Row>
        );
    };

    //  const theSection = currentPath === "/:section";

    // let tokens = queryString.parse(location.search);

    // useEffect(() => {
    //     if (tokens && Object.values(tokens) && Object.values(tokens).length > 0) {
    //         if (Object.values(tokens).every((currentValue) => currentValue == "" && currentValue != null)) {
    //             location.search = "";
    //         }
    //     }
    // }, [location.search]);

    // useEffect(() => {
    //     if (theSection && !location.search) {
    //         for (let filter of searchState.filters) {
    //             filter.data = [];
    //             searchParams.delete(filter.filterName);
    //         }
    //         setSearchParams(searchParams);
    //         searchState.freetext = "";
    //         setValue("");
    //     }
    // }, [theSection, location.search]);

    // console.log("sqliteAdCache.data.length", sqliteAdCache?.data?.length)

    return (
        <Card>
            <Card.Body>
                {sqliteAdCache && sqliteAdCache.isLoading ? (
                    <div>
                        <CenterSpinner />
                        <p>Ett ögonblick medan vi gör dina kurser sökbara</p>
                    </div>
                ) : (
                    <Col>
                        {results && (
                            <HitIndicator results={results}></HitIndicator>
                        )}
                        <Row>
                            <div>
                                <Form.Control
                                    className="mb-1"
                                    type="text"
                                    value={searchState.freetext}
                                    placeholder="Sök"
                                    onChange={(e) => {
                                        if (e.target.value === "") {
                                            searchParams.delete("freetext");
                                        } else {
                                            searchParams.set("freetext", e.target.value);
                                        }

                                        if (slug) {
                                            navigate(`/${section}?${searchParams.toString()}`);
                                        } else {
                                            setSearchParams(searchParams);
                                        }
                                    }}
                                />
                            </div>
                        </Row>
                        {searchState.filters
                            .filter((f) => {
                                return f.showInSearch;
                            })
                            .map((f) => {
                                // return sectionUrl !== "traineeprogram" ||
                                //     f.header === "HUVUDOMRÅDE" ||
                                //     f.header === "GEOGRAFI" || f.header === "KATEGORIER" ? (
                                //     <FilterRow
                                //         adCache={adCache}
                                //         filter={f}
                                //         data={f.data}
                                //         lookupResults={lookupResults}
                                //         setLookupResults={setLookupResults}
                                //     ></FilterRow>
                                // ) : (
                                //     <></>
                                // );
                                console.log("FILTER IS", f);
                                return (
                                    <>
                                        {sectionUrl === "traineeprogram" &&
                                            (f.header === "HUVUDOMRÅDE" ||
                                                f.header === "LÄN" ||
                                                f.header === "ORT" ||
                                                f.header === "KATEGORIER") && (
                                                <FilterRow
                                                    filter={f}
                                                    data={f.data}
                                                    lookupResults={lookupResults}
                                                    setLookupResults={setLookupResults}
                                                    sectionUrl={sectionUrl}
                                                ></FilterRow>
                                            )}
                                        {sectionUrl !== "traineeprogram" && f.header !== "KATEGORIER" && (
                                            <>
                                                <FilterRow
                                                    filter={f}
                                                    data={f.data}
                                                    lookupResults={lookupResults}
                                                    setLookupResults={setLookupResults}
                                                ></FilterRow>
                                            </>
                                        )}
                                    </>
                                );
                            })}

                        <Row>
                            <div>
                                <Button
                                    className="btnWidth"
                                    variant="secondary"
                                    disabled={false}
                                    onClick={(e) => {
                                        for (let filter of searchState.filters) {
                                            filter.data = [];
                                            searchParams.delete(filter.filterName);
                                        }
                                        searchParams.delete("freetext");

                                        if (slug) {
                                            navigate(`/${section}`);
                                        } else {
                                            setSearchParams(searchParams);
                                        }
                                    }}
                                >
                                    <span>Nollställ</span>
                                </Button>
                            </div>
                        </Row>
                    </Col>
                )}
            </Card.Body>
        </Card>
    );
}
